/* Lunari — interacciones propias (prefijo mt-) */
(function () {
  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (sinMovimiento || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var fondos = document.querySelectorAll('[data-mt-parallax]');
    if (!fondos.length || sinMovimiento) return;
    var pendiente = false;
    function mover() {
      fondos.forEach(function (f) {
        var intensidad = parseFloat(f.getAttribute('data-mt-parallax')) || 0;
        var caja = f.parentElement.getBoundingClientRect();
        if (caja.bottom < 0 || caja.top > window.innerHeight) return;
        f.style.transform = 'translate3d(0,' + (-caja.top * intensidad / 100) + 'px,0)';
      });
      pendiente = false;
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(mover); }
    }, { passive: true });
    mover();
  }

  function formatoDinero(centimos, formato) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(centimos, formato);
    formato = formato || '{{amount}}';
    var valor = (centimos / 100).toFixed(2);
    if (/amount_no_decimals/.test(formato)) valor = Math.round(centimos / 100).toString();
    if (/comma_separator/.test(formato)) valor = valor.replace('.', ',');
    return formato.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, valor);
  }

  function initGaleria(raiz) {
    var principal = raiz.querySelector('.mt-galeria__principal');
    if (!principal) return null;
    var imgs = principal.querySelectorAll('img');
    var minis = raiz.querySelectorAll('.mt-galeria__miniaturas button');
    var actual = 0;
    function mostrar(i) {
      if (!imgs.length) return;
      actual = (i + imgs.length) % imgs.length;
      imgs.forEach(function (im, j) { im.classList.toggle('mt-activa', j === actual); });
      minis.forEach(function (m, j) { m.classList.toggle('mt-activa', j === actual); });
    }
    minis.forEach(function (m, j) { m.addEventListener('click', function () { mostrar(j); }); });
    var prev = raiz.querySelector('.mt-galeria__flecha--prev');
    var next = raiz.querySelector('.mt-galeria__flecha--next');
    if (prev) prev.addEventListener('click', function () { mostrar(actual - 1); });
    if (next) next.addEventListener('click', function () { mostrar(actual + 1); });
    var x0 = null;
    principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    principal.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) mostrar(actual + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    return {
      irAMedia: function (mediaId) {
        imgs.forEach(function (im, j) { if (im.getAttribute('data-media-id') === String(mediaId)) mostrar(j); });
      }
    };
  }

  function initCompra(raiz) {
    var form = raiz.querySelector('form[data-mt-form]');
    if (!form) return;
    var datos = raiz.querySelector('script[data-mt-variantes]');
    var variantes = datos ? JSON.parse(datos.textContent) : [];
    var formatoPrecio = raiz.getAttribute('data-mt-money') || '{{amount}}';
    var inputId = form.querySelector('input[name="id"]');
    var boton = form.querySelector('[data-mt-anadir]');
    var textoBoton = boton ? boton.querySelector('span') : null;
    var txtAnadir = boton ? boton.getAttribute('data-texto') : '';
    var txtAgotado = boton ? boton.getAttribute('data-agotado') : '';
    var precio = raiz.querySelector('[data-mt-precio]');
    var antes = raiz.querySelector('[data-mt-antes]');
    var ahorro = raiz.querySelector('[data-mt-ahorro]');
    var mensaje = raiz.querySelector('[data-mt-mensaje]');
    var galeria = initGaleria(raiz);
    var actualizaUrl = raiz.hasAttribute('data-mt-url');

    function opcionesElegidas() {
      var fs = raiz.querySelectorAll('fieldset[data-mt-opcion]');
      return Array.prototype.map.call(fs, function (f) {
        var c = f.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function pintar(v) {
      if (!v) {
        if (boton) { boton.disabled = true; if (textoBoton) textoBoton.textContent = txtAgotado; }
        return;
      }
      inputId.value = v.id;
      if (precio) precio.textContent = formatoDinero(v.price, formatoPrecio);
      var hayAntes = v.compare_at_price && v.compare_at_price > v.price;
      if (antes) { antes.hidden = !hayAntes; if (hayAntes) antes.textContent = formatoDinero(v.compare_at_price, formatoPrecio); }
      if (ahorro) {
        ahorro.hidden = !hayAntes;
        if (hayAntes) ahorro.textContent = ahorro.getAttribute('data-plantilla').replace('[%]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
      }
      if (boton) { boton.disabled = !v.available; if (textoBoton) textoBoton.textContent = v.available ? txtAnadir : txtAgotado; }
      if (galeria && v.featured_media && raiz.hasAttribute('data-mt-foto-opcion')) galeria.irAMedia(v.featured_media.id);
      if (actualizaUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.querySelectorAll('[data-mt-barra-precio]').forEach(function (el) { el.textContent = formatoDinero(v.price, formatoPrecio); });
      raiz.querySelectorAll('[data-mt-pack-precio]').forEach(function (el) {
        var n = parseInt(el.getAttribute('data-mt-pack-precio'), 10);
        var dto = parseInt(el.getAttribute('data-dto'), 10) || 0;
        // Igual que Shopify: descuento redondeado por unidad, hacia abajo
        el.textContent = formatoDinero((v.price - Math.floor(v.price * dto / 100)) * n, formatoPrecio);
        var antes = raiz.querySelector('[data-mt-pack-antes="' + n + '"]');
        if (antes) antes.textContent = formatoDinero(v.price * n, formatoPrecio);
      });
      var stock = raiz.querySelector('[data-mt-stock]');
      if (stock) {
        var umbral = parseInt(stock.getAttribute('data-umbral'), 10) || 0;
        var mostrar = v.stock !== null && v.stock > 0 && v.stock <= umbral;
        stock.hidden = !mostrar;
        if (mostrar) stock.querySelector('[data-mt-stock-texto]').textContent = stock.getAttribute('data-plantilla').replace('[n]', v.stock);
      }
    }

    var cantidadPack = form.querySelector('[data-mt-pack-cantidad]');
    raiz.querySelectorAll('[data-mt-packs] input').forEach(function (inp) {
      inp.addEventListener('change', function () { if (cantidadPack) cantidadPack.value = inp.value; });
    });

    raiz.querySelectorAll('fieldset[data-mt-opcion] input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var elegidas = opcionesElegidas();
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        pintar(v);
      });
    });

    var cant = form.querySelector('.mt-cantidad input');
    form.querySelectorAll('.mt-cantidad button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(cant.value, 10) || 1;
        cant.value = Math.max(1, n + parseInt(b.getAttribute('data-paso'), 10));
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!boton || boton.disabled) return;
      boton.disabled = true;
      boton.setAttribute('aria-busy', 'true');
      if (mensaje) mensaje.textContent = '';
      var carrito = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var fd = new FormData(form);
      if (carrito && typeof carrito.getSectionsToRender === 'function') {
        fd.append('sections', carrito.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        if (typeof carrito.setActiveElement === 'function') carrito.setActiveElement(document.activeElement);
      }
      var rutaAnadir = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(rutaAnadir, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      })
        .then(function (r) { return r.json(); }, function () { form.submit(); return null; })
        .then(function (res) {
          if (!res) return;
          if (res.status) {
            if (mensaje) mensaje.textContent = res.description || res.message || 'Error';
            return;
          }
          // Ya está en el carrito: si el cajón falla, solo redirigimos (nunca reenviar el formulario)
          try {
            if (!carrito || typeof carrito.renderContents !== 'function') throw new Error('sin cajón');
            if (carrito.classList.contains('is-empty')) carrito.classList.remove('is-empty');
            carrito.renderContents(res);
          } catch (err) {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .finally(function () {
          boton.removeAttribute('aria-busy');
          var elegido = variantes.find(function (x) { return String(x.id) === inputId.value; });
          boton.disabled = elegido ? !elegido.available : false;
        });
    });
  }

  function initBarra() {
    var barra = document.querySelector('.mt-barra');
    var objetivo = document.querySelector('[data-mt-anadir]');
    if (!barra || !objetivo || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (e) {
      var fuera = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      barra.classList.toggle('mt-visible', fuera);
    });
    io.observe(objetivo);
    var b = barra.querySelector('button');
    if (b) b.addEventListener('click', function () {
      objetivo.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'center' });
    });
  }

  // Cuenta atrás hasta la fecha real de fin de la oferta (la misma del descuento en Shopify)
  function initCuentas() {
    document.querySelectorAll('[data-mt-cuenta]').forEach(function (el) {
      if (el.dataset.mtIniciada) return;
      el.dataset.mtIniciada = '1';
      var fin = Date.parse(el.getAttribute('data-mt-cuenta'));
      if (isNaN(fin)) { el.hidden = true; return; }
      var u = {};
      el.querySelectorAll('[data-u]').forEach(function (b) { u[b.getAttribute('data-u')] = b; });
      function dos(n) { return (n < 10 ? '0' : '') + n; }
      function tic() {
        var resto = Math.floor((fin - Date.now()) / 1000);
        if (resto <= 0) { el.hidden = true; clearInterval(t); return; }
        u.d.textContent = dos(Math.floor(resto / 86400));
        u.h.textContent = dos(Math.floor(resto % 86400 / 3600));
        u.m.textContent = dos(Math.floor(resto % 3600 / 60));
        u.s.textContent = dos(resto % 60);
      }
      var t = setInterval(tic, 1000);
      tic();
    });
  }

  // Las estrellas llevan a la sección de reseñas (su id real acaba en "__reviews")
  function irAResenas(suave) {
    var destino = document.querySelector('[id$="__reviews"]');
    if (!destino) return false;
    destino.scrollIntoView({ behavior: suave && !sinMovimiento ? 'smooth' : 'auto', block: 'start' });
    return true;
  }
  function initResenas() {
    document.querySelectorAll('[data-mt-ir-resenas]').forEach(function (a) {
      if (a.getAttribute('href') !== '#reviews') return;
      a.addEventListener('click', function (e) { if (irAResenas(true)) e.preventDefault(); });
    });
    if (window.location.hash === '#reviews') setTimeout(function () { irAResenas(false); }, 600);
  }

  function init() {
    initResenas();
    initCuentas();
    initReveal();
    initParallax();
    document.querySelectorAll('[data-mt-compra]').forEach(initCompra);
    initBarra();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
